import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';

import CustomFieldRenderer from './CustomFieldRenderer';

import { useOrderCustomFields } from '../../../hooks/useOrderCustomFields';

const OrderCustomFields = () => {
  const { getValues, setValue, formState } = useFormContext();
  const { errors } = formState;
  const {
    splittedFields,
    updateCustomField,
    handleInputChange,
    handleBooleanToggle,
    toggleKey
  } = useOrderCustomFields({
    getValues,
    setValue
  });

  if (splittedFields.length === 0) return null;

  return (
    <div className="tw-wrapper">
      <div className="tw-flex tw-flex-col tw-gap-2">
        {splittedFields.map((group) => (
          <div
            key={group[0]?.id}
            className="tw-flex tw-gap-2"
          >
            {group.map((field) => (
              <CustomFieldRenderer
                key={field.id}
                field={field}
                getValues={getValues}
                updateCustomField={updateCustomField}
                handleInputChange={handleInputChange}
                handleBooleanToggle={handleBooleanToggle}
                toggleKey={toggleKey}
                error={errors?.customFields?.[field.name]}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(OrderCustomFields);
